import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import axios from 'axios';
import Notify from 'quasar/src/plugins/Notify.js';;
import getError from 'src/utils/errors-catalog.js';
import getErrorOpenPay from 'src/utils/errors-openpay-catalog.js';
var axiosInstance = axios.create({
  baseURL: process.env.API
});
export default (function (_ref) {
  var Vue = _ref.Vue,
      store = _ref.store,
      router = _ref.router;
  Vue.prototype.$axios = axiosInstance;
  axiosInstance.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    if (getErrorOpenPay(error.response.data.code) === undefined) {
      if (error.response.data.code === 'INVALID_QUANTITY' && error.response.data.status === 406) {
        Notify.error('No hay existencias disponibles.');
        Notify.error("No hay ".concat(error.response.data.message, " disponibles."));
      } else {
        if (error.response.data.status !== 412) {
          Notify.error(getError(error.response.status, error.response.data.code));
        }
      }
    } else {
      Notify.error(getErrorOpenPay(error.response.data.code));
    }

    if (error.response.status === 401) {
      store.dispatch('auth/clean');
      router.push({
        name: 'home'
      }).catch(function (err) {});
    }

    return Promise.reject(error);
  });
});
export { axiosInstance };